import { Modal, ModalProps } from "Components/ReactstrapSlim";
import React, { useEffect, useState } from "react";
import classes from "./styles.module.scss";
import LeftBottomLine from "./LeftBottomLine";
import ModalCloseButton from "Components/ReactstrapSlim/Modals/ModalCloseButton";
import classNames from "classnames";
import NotifyForm from "../NotifyForm";
import NotifyFormConfirmation from "../NotifyFormConfirmation";

enum Step {
   NotifyForm,
   Confirmation
}

interface CheckAvailabilityModalProps {
   isOpen?: ModalProps["isOpen"];
   toggle?: () => void;
   venueId: Guid;
   citySearchUrl?: string;
}

const CheckAvailabilityModal: React.FC<CheckAvailabilityModalProps> = ({ isOpen, toggle, venueId, citySearchUrl }) => {
   const [step, setStep] = useState(Step.NotifyForm);

   const onNotifyFormSuccess = () => setStep(Step.Confirmation);

   useEffect(() => {
      if (isOpen) {
         setStep(Step.NotifyForm);
      }
   }, [isOpen]);

   return <Modal className={classNames(classes.modal, {
      [classes.modalNotifyForm]: step == Step.NotifyForm,
      [classes.modalConfirmation]: step == Step.Confirmation,
   })} isOpen={isOpen} centered toggle={toggle} contentClassName={classes.content}>
      {
         step == Step.NotifyForm
            ? <>
               <div className={classes.contentLeft}>
                  <LeftBottomLine />
               </div>
               <div className={classes.contentRight}>
                  <ModalCloseButton className={classNames("close", classes.close)} onClick={toggle} />
                  <NotifyForm venueId={venueId} onSuccess={onNotifyFormSuccess} />
               </div>
            </>
            : step == Step.Confirmation
               ? <div className={classes.confirmation}>
                  <ModalCloseButton className={classNames("close", classes.close)} onClick={toggle} />
                  <NotifyFormConfirmation citySearchUrl={citySearchUrl} />
               </div>
               : null
      }

   </Modal>;
}

export default CheckAvailabilityModal;